import App from '@/models/App'
import Feature from '@/models/Feature'

export default class ShipFeature extends App {
    static get entity() {
        return 'ShipFeatures'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            featureId: this.attr(''),
            feature: this.belongsTo(Feature, 'featureId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/features`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            fetchByShipId(shipId) {
                return this.get(`${shipId}/features`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
